<template>
	<!-- 标签查询管理 -->
	<div class="el-container container_cloumn" v-loading="pageloading">
		<vxe-toolbar>
			<template v-slot:buttons>
				<div class="flex flex_row flex-nowrap">
					<span class="_button flex flex_row flex-nowrap flex-vc _select">
						<span class="vxe-cell--required-icon"></span>打印功能
						<vxe-select v-model="print" @change="changePrint">
							<vxe-option v-for="(module,index) in printList" :key="index" :value="module['代码']"
								:label="module['名称']"></vxe-option>
						</vxe-select>
					</span>
					<el-button @click="select" :loading="loading" :disabled="loading" type="primary">查询</el-button>
					<el-button @click="filterForm={}">清除</el-button>
					<!-- <div class="panel_hidden"> -->
					<c-filter :dataSource="(filterList||[]).slice(0,4)" :form="filterForm" :wrap="false"></c-filter>
					<!-- </div> -->
				</div>
			</template>
		</vxe-toolbar>
		<vxe-toolbar size="mini">
			<template v-slot:buttons>
				<div class="flex flex_row flex-nowrap flex-vc">
					<el-button @click="createCodeInDo({value:'print_already',type:'preview',name:'createModalV'})"
						:loading="createModalV" :disabled="createModalV">预览</el-button>
					<el-button @click="createCodeInDo({value:'print_already',type:'print',name:'createModalP'})"
						:loading="createModalP" :disabled="createModalP">重新打印</el-button>
					<el-button @click="createCodeInDo({value:'invalid_already'})" :loading="invalidLoading"
						:disabled="invalidLoading">标签作废</el-button>
					<el-checkbox class="vuxcheckbox" v-model="createdChangeP">切换模板</el-checkbox>
					<span class="_button flex flex_row flex-nowrap flex-vc">
						标签模板
						<vxe-select v-model="module" :disabled="!createdChangeP">
							<vxe-option v-for="(module,index) in moduleList" :key="index" :value="module['代码']"
								:label="module['名称']"></vxe-option>
						</vxe-select>
					</span>
				</div>
			</template>
			<template v-slot:tools>
				<vxe-button type="text" class="tool-btn _icon_button" title="筛选" @click="$refs.filtermodal.open()">
					<i class="iconfont vxe-button--icon vxe-icon--funnel iconSize "></i>
				</vxe-button>
				<vxe-button type="text" class="tool-btn _icon_button" title="导出数据"
					@click="$refs.ctable.exportDataEvent()">
					<i class="iconfont icon-export iconSize "></i>
				</vxe-button>
				<!-- <vxe-button type="text" class="tool-btn _icon_button" title="页面设置" @click="toSetting({value:'design'})">
					<i class="iconfont icon-setting iconSize " ></i>
				</vxe-button> -->
			</template>
		</vxe-toolbar>
		<!-- <div class="table_height">123</div> @close="$refs.ctable.$refs.xTable.clearCheckboxRow();modaltable.table=[];modaltable.head=[];"-->
		<c-table ref="ctable" :table="table" class="table_height print_selecttable_div" v-loading="loading"></c-table>
		<vxe-modal ref="filtermodal" title="筛选条件" :mask="false" :show-zoom="true" :resize="true" :lock-view="false"
			width="700" height="500" remember :zIndex="2001">
			<template v-slot:header>
				<el-button @click="select" :loading="loading" :disabled="loading">查询</el-button>
				<el-button @click="filterForm={}">清除</el-button>
				<el-button @click="$refs.filtermodal.close()">退出</el-button>
			</template>
			<template v-slot>
				<div style="width: 100%;">
					<c-filter :dataSource="filterList" :form="filterForm" :wrap="true"></c-filter>
				</div>
			</template>
		</vxe-modal>
		<vxe-modal ref="tablePageset" title="设置" :mask="false" :show-zoom="true" :resize="true" :lock-view="false"
			width="600" height="500">
			<template v-slot>
				<el-tabs ref="eltabs" v-model="activeName">
					<el-tab-pane label="列显示设置" name="first"></el-tab-pane>
					<el-tab-pane label="过滤条件设置" name="second"></el-tab-pane>
				</el-tabs>
				<vxe-toolbar>
					<template v-slot:buttons>
						<div class="flex flex_row flex-nowrap">
							<el-button
								@click="createCodeInDo({value:'print_already',type:'preview',name:'createModalV'})"
								:loading="createModalV" :disabled="createModalV">保存</el-button>
						</div>
					</template>
				</vxe-toolbar>
				<div class="modal_table_div">
					<!-- 序号/列名/列宽/显示/显示名称/是否固定列 -->
					<!-- 列名/数据类型/过滤条件 -->
					<!-- <c-table ref="ctableModaltable" :table="modaltable" class="table_height" coltype="checkbox" @getRow="getCurrenMoudle"></c-table> -->
				</div>
			</template>
		</vxe-modal>
	</div>
</template>

<script>
	import cfilter from './filter.vue'
	export default {
		data() {
			return {
				loading: false,
				filterForm: {},
				filterList: [],
				table: {
					pagesize: 15,
					currentPage: 1,
					head: [],
					data: [],
					_height: undefined
				},
				createdChangeP: false,
				module: '',
				moduleList: [],
				pageloading: false,
				printList: [],
				print: '',
				createModalV: false,
				invalidLoading: false,
				createModalP: false,
				activeName: 'first'
			}
		},
		computed: {
			TabItem() {
				if (this.routePath) {
					return {};
				}
				if (this.$route.meta.menu) {
					return this.$route.meta.menu[this.$route.fullPath];
				}
				return {};
			}
		},
		components: {
			'c-filter': cfilter
		},
		methods: {
			changePrint({
				value
			}) {
				try {
					this.pageloading = true;
					console.log(value)
					this.table = {
						pagesize: 15,
						currentPage: 1,
						head: [],
						data: [],
						_height: undefined
					}
					if (this.$refs.filtermodal)
						this.$refs.filtermodal.close();
					this.$refs.ctable.$refs.xTable.clearAll();
					this.$BH().commit('printManager.getPrintInit', {
						data: {
							FUser: this.$store.getters.UserInfo.username,
							FuncNumber: value,
							FFormName: this.TabItem['FFormName'],
							PageNumber: this.TabItem['FNumber']
						},
						loadingcontrol: (res) => {
							this.pageloading = false;
						},
						success: (response) => {
							let {
								head,
								init
							} = response.data.value;
							this.table.head = head.columns;
							this.moduleList = init.template.template;
							let module = init.template.template1[0];
							this.module = module ? module['ftnumber'] : undefined;
							let {
								filter,
								columns
							} = init;
							let filterarr;
							if (filter && filter.length > 0) filterarr = filter;
							else filterarr = columns;
							//列名 数据类型
							let tempFilter = []
							for (let i in filterarr) {
								let name = filter && filter.length > 0 ? '列名' : '数据源列';
								let currentobj = {};
								currentobj['Display'] = filterarr[i][name];
								currentobj['name'] = filterarr[i][name];
								if (filterarr[i]['数据类型'].includes('varchar') || filterarr[i]['数据类型'].includes(
										'String'))
									currentobj['type'] = 1;
								else if (filterarr[i]['数据类型'].includes('datetime') || filterarr[i]['数据类型']
									.includes('DateTime'))
									currentobj['type'] = 3;
								else if (filterarr[i]['数据类型'].includes('bit') || filterarr[i]['数据类型'].includes(
										'Bool'))
									currentobj['type'] = 4;
								if (currentobj['type'])
									tempFilter.push(currentobj);
							}
							this.filterList = tempFilter;
							this.$forceUpdate()
						}
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.pageloading = false;
				}
			},
			select() {
				try {
					this.loading = true;
					this.$refs.ctable.$refs.xTable.clearCheckboxRow();
					this.$refs.ctable.$refs.xTable.clearCheckboxReserve();
					this.$BH().commit('printManager.PrintManageGetData', {
						data: {
							FUser: this.$store.getters.UserInfo.username,
							FuncNumber: this.print,
							FFormName: this.TabItem['FFormName'],
							PageNumber: this.TabItem['FNumber'],
							filterForm: this.filterForm,
							filterList: this.filterList
						},
						loadingcontrol: (res) => {
							this.loading = false;
						},
						success: (response) => {
							let {
								head
							} = response.data.value;
							this.table.data = head.data;
						}
					});
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
					this.loading = false;
				}

			},
			toSetting() {

			},
			async createCodeInDo({
				value,
				type,
				name
			}) {
				try {
					var selectData = [];
					var printset = this.$store.getters.UserInfo._printset; //localStorage.getItem('printset');
					if (value.includes('print')) {
						//检查是否已经选择了打印的方式
						if (printset == null || String(printset) == 'undefined') {
							this.$confirm('请先设置打印方式', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.$refs.printset.open();
							})
							return;
						}
						if (printset != 'M10' && printset != 'WebHtml' && printset != 'socket') {
							this.$confirm('请先设置打印方式', '提示', {
								confirmButtonText: '确定',
								cancelButtonText: '取消',
								type: 'warning'
							}).then(() => {
								this.$refs.printset.open();
							})
							return;
						}
					}
					if (!value.includes('design'))
						if (value.includes('already')) {
							let selectRecords = this.$refs.ctable.$refs.xTable.getCheckboxRecords();
							let selectreverse = this.$refs.ctable.$refs.xTable.getCheckboxReserveRecords();
							if (selectRecords.length == 0 && selectreverse.length == 0) throw "未选择记录";
							selectData = selectreverse.concat(selectRecords);
						}
					if (selectData.length == 0) throw "未选择记录";
					//打印标签
					if (value.includes('print')) {
						if (value.includes('already')) {
							if (!this.createdChangeP) { //不强制
								for (let i in selectData) {
									if (selectData[0]['打印模板'] != selectData[i]['打印模板']) {
										throw "选中记录模板不一致";
									}
								}
								this.module = selectData[0]['打印模板'];
								if (printset == 'M10') return;
								// this.toPrint();
								this[name] = true;
								await this.$BH().commit('print.toPrint', {
									data: {
										templateNumber: this.module,
										moudleData: selectData,
										FuncNumer: this.print,
										strUser: this.$store.getters.UserInfo.username
									},
									type,
									loadingcontrol: () => {
										this[name] = false;
									}
								})
							} else {
								if (!this.module || this.module == '') {
									this.$BH().message('请先选择模板');
									return;
								}
								if (printset == 'M10') return;
								this[name] = true;
								await this.$BH().commit('print.toPrint', {
									data: {
										templateNumber: this.module,
										moudleData: selectData,
										FuncNumer: this.print,
										strUser: this.$store.getters.UserInfo.username
									},
									loadingcontrol: () => {
										this[name] = false;
									},
									type
								})
							}
						}
					}
					//作废标签
					if (value.includes('invalid')) {
						this.invalidLoading = true;
						await this.$BH().commit('print.invalidCode', {
							data: {
								rows: selectData,
								user: this.$store.getters.UserInfo.username
							},
							success: () => {
								this.$BH().message('作废成功');
								for (let i in selectData) {
									selectData[i]['标签状态'] = '作废';
								}
							},
							loading: () => {
								this.invalidLoading = false;
							}
						});
					}
				} catch (e) {
					//TODO handle the exception
					this.$BH().message(e);
				}
			},
		},
		activated() {
			// console.log('activated')
			// console.log(this.TabItem,this.$route.meta.menu[this.$route.fullPath])
			if (this.pageloading == false) {
				this.table._height = '85%';
			}
		},
		deactivated() {
			// console.log('deactivated')
			// if(this.pageloading==false){
			if (document.getElementsByClassName('print_selecttable_div') && document.getElementsByClassName(
					'print_selecttable_div')[0])
				this.table._height = document.getElementsByClassName('print_selecttable_div')[0].offsetHeight * 0.85;
			// }
		},
		created() {
			this.pageloading = true;
			this.$BH().commit('printManager.getPrintList', {
				data: {
					FUser: this.$store.getters.UserInfo.username
				},
				loadingcontrol: (res) => {
					this.pageloading = false;
				},
				success: (response) => {
					this.printList = response.data.value;
				}
			});
		}
	}
</script>

<style scoped>
	.container_cloumn {
		flex-direction: column;
		height: 100%;
		width: 100%;
	}

	.vxe-toolbar.size--mini * {
		font-size: 12px;
	}

	.table_height {
		height: 100px;
		height: calc(100% - 100px);
		/* overflow: auto; */
	}

	.vuxcheckbox {
		margin-left: 10px;
		font-size: 12px;
	}

	._select+button {
		margin-left: 10px;
	}

	._select {
		font-weight: 700;
	}

	.vxe-cell--required-icon:before {
		content: "*";
		position: absolute;
		left: 0;
		top: .9em;
		color: red;
	}

	._select .vxe-cell--required-icon {
		vertical-align: middle;
	}
</style>
